import getNavigationElement from './get-navigation-element';

export default {
  getNavigationElement,
};
